import PackagingBaseScreen from "../../shared/packaging/PackagingBaseScreen";
import Packaging from "./Packaging";
import PackagingMethod from "./PackagingMethod";

export const ProcessGatePackagingBase = ({ modalData }: { modalData: any }) => (
  <PackagingBaseScreen
    gate="process-gate"
    modalData={modalData}
    Packaging={Packaging}
    PackagingMethod={PackagingMethod}
  />
);